<template>
  <div class="loading" :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mloading' : 'loading'
    ">
    <img v-if="this.$Base.langPicClass() == 'vi-VN'" src="../../assets/vi/logo.png" alt="" />
    <img v-else src="../../assets/logo.png" alt="" />
    <div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RastarLoading",
  porp: [],
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>